import type { AddButton, RicosServices } from './../ricos-types';
import { Node_Type } from './../ricos-types';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from './../editor-common';

import { INSERT_GALLERY_BUTTON } from './data-hooks';
import { handleGalleryUpload } from './handle-gallery-upload';
import { InsertPluginIcon } from './icons';
import type { GalleryPluginEditorConfig } from './types';

export const toolbarsToAddIn: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE,
];

export const getAddButtons = (
  config: GalleryPluginEditorConfig | undefined,
  services?: RicosServices
): AddButton[] => {
  return [
    {
      id: Node_Type.GALLERY,
      label: INSERT_PLUGIN_BUTTONS.GALLERY,
      dataHook: INSERT_GALLERY_BUTTON,
      icon: InsertPluginIcon,
      tooltip: 'GalleryPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        const { updateService } = services || {};

        if (updateService === undefined) {
          return true;
        }

        if (!services) {
          return false;
        }

        handleGalleryUpload({ publicCommands, services, config });
        return true;
      },
      menuConfig: {
        tags: 'Gallery_plugin_search_tags',
      },
    },
  ];
};
